import React from 'react';
import {
  Button,
  Divider,
  Form,
  Grid,
  Icon,
  Accordion,
} from 'semantic-ui-react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';

import {
  InputField,
  SelectField,
  DatePickerField,
} from 'Common/SemanticWrapper';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import { CreateEditUsageEnum, FilterEnum } from 'Common/FieldEnum';
import { DatePickerCustomButton } from 'Components';
import { GenericFiltersContainer } from 'Components/filters/container';
import { TableNamesEnum } from 'Common/Constants/Enumeration/TableEnum';
import { GridEnum } from 'Common/Constants/Enumeration/GridEnum';
import { ItemGridFormField } from 'Components';
import { SiteComponent } from 'Common/SiteComponent';
import { SiteTypeEnum } from 'Common/Constants/Enumeration/SiteTypeEnum';

const CreateEditUsageComponent = props => {
  const {
    assignItemsBidGroupData,
    assignItemsItemGroupData,
    filterValues,
    usageItemsData,
    onChangeOfUsageDT,
    onChangeOfSite,
    handleChange,
    clearFilters,
    fetchUsageItems,
    isDisabled,
    onResetPageOnDataChange,
    resetPageOnDataChange,
    activeIndexForFilter,
    handleClick,
  } = props;

  const fields = [
    {
      name: FilterEnum.GroupId_Item,
      component: SelectField,
      type: 'text',
      options: assignItemsItemGroupData,
      label: 'ITEM GROUP',
    },
    {
      name: FilterEnum.GroupId_Bid,
      component: SelectField,
      type: 'text',
      options: assignItemsBidGroupData,
      label: 'BID GROUP',
      maxLength: 20,
    },
  ];

  return (
    <Form>
      <Grid>
        <Grid.Row columns={4}>
          <Grid.Column>
            <Field
              component={DatePickerField}
              label={'Usage Date'}
              dateFormat={DATE_FORMAT_FOR_UI}
              name={CreateEditUsageEnum.UsageDT}
              type={'text'}
              dropdownMode="select"
              onChange={onChangeOfUsageDT}
              customInput={<DatePickerCustomButton isDisabled={isDisabled} />}
            />
          </Grid.Column>
          <Grid.Column>
            <SiteComponent
              name={CreateEditUsageEnum.Site}
              label={'Site'}
              onChange={(newVal, preVal, field) =>
                onChangeOfSite(null, newVal, preVal, field)
              }
              disabled={isDisabled}
              isForm={true}
              siteMasterTypeIds={[SiteTypeEnum.School, SiteTypeEnum.Kitchen]}
              isAllRequired={false}
              checkIsLicensed={false}
            />
          </Grid.Column>
          <Grid.Column>
            <Field
              name={CreateEditUsageEnum.Comments}
              component={InputField}
              type="text"
              maxLength={50}
              label={'Comments'}
              disabled={isDisabled}
            />
          </Grid.Column>
          <Grid.Column />
        </Grid.Row>
      </Grid>
      <Accordion fluid styled>
        <Accordion.Title
          active={!activeIndexForFilter}
          index={0}
          onClick={handleClick}
        >
          <Icon name="dropdown" />
          <span className="text-orange">Filter By</span>
        </Accordion.Title>
        <Accordion.Content active={!activeIndexForFilter}>
          <Grid className={'remove-spacing'}>
            <GenericFiltersContainer
              fields={fields}
              onChange={handleChange}
              filterValues={filterValues}
            />
            <Grid.Row>
              <Grid.Column>
                <Button
                  className={'clear-filters-button'}
                  content="Clear Filters"
                  onClick={clearFilters}
                  type={'button'}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Accordion.Content>
      </Accordion>
      <Divider horizontal />
      <Grid>
        <Grid.Row>
          <Grid.Column>
            <Field
              component={ItemGridFormField}
              name={CreateEditUsageEnum.UsageItemsInfo}
              {...{
                dataSource: usageItemsData,
                fetchOrderItems: fetchUsageItems,
                gridName: GridEnum.INV_UsageList_CreateEdit_View,
                tableName: TableNamesEnum.USAGE_LIST_CREATE_EDIT_TABLE,
                onResetPageOnDataChange: onResetPageOnDataChange,
                resetPageOnDataChange: resetPageOnDataChange,
                showCalc: true,
              }}
              disabled={isDisabled}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Form>
  );
};

CreateEditUsageComponent.propTypes = {
  onChangeOfUsageDT: PropTypes.func,
  onChangeOfSite: PropTypes.func,
  onResetPageOnDataChange: PropTypes.func,
  handleClick: PropTypes.func,
  handleChange: PropTypes.func,
  clearFilters: PropTypes.func,
  assignItemsBidGroupData: PropTypes.array.isRequired,
  assignItemsItemGroupData: PropTypes.array.isRequired,
  usageItemsData: PropTypes.array.isRequired,
  filterValues: PropTypes.object,
  activeIndexForFilter: PropTypes.number,
  fetchUsageItems: PropTypes.bool,
  isDisabled: PropTypes.bool,
  resetPageOnDataChange: PropTypes.bool,
};
CreateEditUsageComponent.defaultProps = {
  onChangeOfUsageDT: () => {},
  onChangeOfSite: () => {},
  onResetPageOnDataChange: () => {},
  handleClick: () => {},
  handleChange: () => {},
  clearFilters: () => {},
  filterValues: {},
  activeIndexForFilter: 0,
  fetchUsageItems: false,
  isDisabled: false,
  resetPageOnDataChange: true,
};
export default CreateEditUsageComponent;



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/usage/components/createEditUsage/CreateEditUsage.js